export default {
  methods: {
    getAvatarSources(origSrc, width = null) {
      const compiledSrc =
        origSrc?.replace(
          process.env.S3_BUCKET_URL,
          process.env.CLOUDFRONT_URL
        ) ?? null

      let sources = { src: '' }

      if (compiledSrc) {
        const src = width ? compiledSrc + `?width=${width}` : compiledSrc
        const webp = width
          ? compiledSrc + `?width=${width}&format=webp`
          : `${compiledSrc}?format=webp`

        sources = {
          src,
          webp,
        }
      }
      return sources
    },
  },
}
